import React, { useEffect, useState } from "react";
import { GetFishParam } from "../adapters/GetFishParam";

const useGetParams = () => {
  const [params, getParams] = useState(null);

  useEffect(() => {
    GetFishParam(getParams);
  }, []);
  return params;
};

export default useGetParams;
